import * as React from 'react';
import { ModalProps } from 'antd/es/modal';
import { useState } from 'react';
import t from 'utils/translations';
import ModalBase from 'components/common/ModalBase';
import styled from 'styled-components';
import { apiDeleteGroup } from 'api/groups';
import { message } from 'antd';

export const ConfirmationModal = styled(ModalBase)`
    p {
        font-size: 18px;
    }

    p:last-of-type {
        margin-bottom: 0;
    }
`;

interface Props extends ModalProps {
    afterSuccess: () => void;
    closeModal: () => void;
    groupId: string;
    name: string;
}

function DeleteGroupModal({
    afterSuccess,
    closeModal,
    groupId,
    name,
    visible
}: Props) {
    const [isLoading, setIsLoading] = useState(false);

    function handleCancel() {
        closeModal();
    }

    function handleOk() {
        setIsLoading(true);
        apiDeleteGroup(groupId)
            .then(res => {
                if (res.status === 200) {
                    message.success(t('GROUP_DELETE_SUCCESS'));
                    setIsLoading(false);
                    afterSuccess();
                    closeModal();
                }
            })
            .catch(() => {
                message.error(t('GROUP_DELETE_FAIL'));
                setIsLoading(false);
            });
    }

    return (
        <ConfirmationModal
            cancelText={t('CANCEL_MODAL')}
            confirmLoading={isLoading}
            destroyOnClose={true}
            onCancel={() => handleCancel()}
            onOk={() => handleOk()}
            okText={t('DELETE_GROUP')}
            title={t('DELETE_GROUP_MODAL_TITLE')}
            visible={visible}
        >
            <>
                <p>{`${t('DELETE_GROUP_CONFIRM')} "${name}"?`}</p>
            </>
        </ConfirmationModal>
    );
}

export default DeleteGroupModal;
